import { SELECT_INCIDENT_SEARCH } from "./incidentActionTypes";

export default (state = '', action) => {
    switch (action.type) {
        case SELECT_INCIDENT_SEARCH: {    
            return action.value;
        }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/incidents/incidentsSearchFilterReducer.js